/* esm.sh - @radix-ui/number@1.1.1 */
export * from "/*@radix-ui/number@1.1.1/esnext/number.mjs";
